<template>
  <div class="component-content sub-content">
    <div class="tip">* 业务性退库仅限用于历史工程领料/维修/新购等退库</div>
    <div class="list-title">
      <div class="r">
        <router-link v-if="backRole('ST_16')" :to="'/Storage/MaterialBackForce/' + houseId">
          <el-button type="primary" size="mini">提交业务性退库</el-button>
        </router-link>
      </div>

      <label class="label-name">当前仓库：</label>
      <el-select size="mini" class="organization-select" v-model="houseId" placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <label style="width:40px;text-align:left;margin-left:15px;">搜索：</label>
      <el-input style="width:300px;" v-model="filterName" size="mini" placeholder="你可以搜索退库单号">
      </el-input>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column label="退库单号" width="100">
        <template slot-scope="scope">
          <a href="javascript:void(0)" @click="ShowMaterialBackDetail(scope.row)">{{ scope.row.number }}</a>
        </template>
      </el-table-column>
      <el-table-column label="退库材料">
        <template slot-scope="scope">
          <span v-html="scope.row.outMaterials"></span>
        </template>
      </el-table-column>
      <el-table-column label="退库名称" width="200px">
        <template slot-scope="scope">
          <span v-html="scope.row.name"></span>
        </template>
      </el-table-column>
      <el-table-column label="退库人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="退库时间" width="140px">
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="材料退库详情" placement="bottom">
            <i class="iconfont icon-157 meeting-btn-icon mbi-detail" @click="ShowMaterialBackDetail(scope.row)"></i>
          </el-tooltip>

          <!-- <el-button plain size="mini" @click="ShowMaterialInEdit(scope.row)" type="success">编辑</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length > pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <material-back-force-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus"
      :materialBackForceData="materialBackData" :backType="1">
    </material-back-force-detail>

  </div>
  </div>
</template>

<script>
import {
  mapState
} from "vuex";

import Role from '@/Mixins/role'
import UserInfo from '@/components/UserInfo'
import materialBackForceDetail from './components/materialBackForceDetail'
export default {
  components: {
    UserInfo,
    materialBackForceDetail,
  },
  mixins: [Role],
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData,
      managerStorage: state => state.storage.managerStorage,
    })
  },
  data() {
    return {
      // 编辑退库单
      editMaterialInStatus: false,
      form: {
        inId: '',
        inVoice: '',
        supplierId: '',
      },
      supplierList: '',
      // 退库单明细详情
      detailStatus: false,
      materialBackData: "",

      houseId: "",
      depId: "",
      houseList: "",

      organizationListData: [],
      noSelectOrganization: true,
      // 列表
      filterName: "",
      filterTimeout: null,
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],
    }
  },
  created() {
    if (this.$route.params.houseId) {
      this.houseId = this.$route.params.houseId / 1
    }
    this.depId = this.userData.secDepIds.split(",")[0] / 1
    // 获取仓库列表
    this.getHouseList()

    // 获取供应商列表
    ajax.get('/supplier/list', {
      'type': 1
    }, (res) => {
      this.loading = false
      this.supplierList = res.vo.array
    })
  },
  mounted() {
    this.organizationListData = this.organization[0].childDepts
    this.depId = this.userData.secDepIds.split(",")[0] / 1

    if (this.userData.secDepIds.split(",")[0] == "7") {
      this.noSelectOrganization = false
    }
  },
  methods: {
    // 显示退库单详情
    ShowMaterialBackDetail(row) {
      this.materialBackData = row
      this.detailStatus = true
    },
    // 隐藏详情
    hideDetail() {
      this.detailStatus = false
    },
    // 组装退库单材料
    getOutMaterials(row) {
      let _m = []
      for (var i = 0; i < row.materials.length; i++) {
        let _item = row.materials[i]
        _m.push(_item.name + '（' + _item.amount + _item.unitName + '）')
      }
      return _m.join(",")
    },
    // 获取仓库列表
    getHouseList() {
      // 只能看到拥有权限的仓库
      this.houseList = this.managerStorage

      if (!this.houseId && this.houseList.length > 0) {
        this.houseId = this.houseList[0].id
      }

      this.getLists()
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPaginationData()
    },
    // 搜索筛选新闻数据
    getFilterData() {
      this.form.page = 0;
      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      // 分页筛选
      this.paginationData = this.filterData;
    },
    // 获取列表
    getLists() {
      if (!this.houseId) {
        return
      }
      this.loading = true

      ajax.get('/storage/material/back/force/list', {
        "houseId": this.houseId,
        page: 0,
        pageSize: 20,
        number: this.filterName,
      }, (res) => {
        this.loading = false

        // 循环出所有退库材料至list
        let _list = res.vo.list
        for (let i = 0; i < _list.length; i++) {
          _list[i].outMaterials = this.getOutMaterials(_list[i])
        }

        this.filterData = this.listData = _list
        this.form.pageTotal = res.vo.size;
        this.getPaginationData()
      })
    },
  },
  watch: {
    "houseId"() {
      this.getLists()
    },
    "filterName"() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.getFilterData();
      }, 350)
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/page/storage/materialBackForceList.vue